<template>
    <v-row v-if="app_user_statistic" no-gutters align="center" class="pa-1" :style="rowStyle">
        <v-col v-if="!isMobile" cols="3" sm="2">
            <EspAvatar 
            :size="40"
            :color="(app_team_photo && app_team_photo.thumb)?'white':'grey'"
            :src="(app_team_photo && app_team_photo.thumb)?`${app_team_photo.baseUrl}${app_team_photo.thumb}`:null"
            :alt="app_user_statistic.name"
            />
        </v-col>
        <v-col v-if="!isMobile" cols="9" sm="10">
            <div class="pl-5">
                <div class="three-dots grey--text text--darken-2 font-weight-bold" :style="{'color':theme.footerIconColor + '!important'}">{{app_team_name}}</div>
                <div><v-icon small :color="theme.footerIconColor">mdi-star-circle</v-icon> <span style="font-size:0.8em;font-weight: 600;" class="grey--text" :style="{'color':theme.footerIconColor + '!important'}">{{app_user_statistic.punkte_gesamt}}</span></div>
            </div>
        </v-col>
        <!-- Mobile component  -->
        <v-col v-if="isMobile" cols="3" sm="2">
            <v-menu 
                bottom
                offset-y
                rounded="b-xl t-0"
                content-class="mt-1 menuShadow"
                outlined
                >
                <template v-slot:activator="{ on, attrs }">
                    <EspAvatar 
                        :size="40" 
                        :color="(app_team_photo && app_team_photo.thumb)?'white':'grey'"
                        :src="(app_team_photo && app_team_photo.thumb)?`${app_team_photo.baseUrl}${app_team_photo.thumb}`:null"
                        :alt="app_user_statistic.name"
                        :menuAttrs="attrs"
                        :menuOn="on"
                    />
                </template>
                <span>
                    <v-card
                        class="mx-auto"
                        max-width="275"
                        tile
                    >
                        <v-card-text :style="{'background-color': theme.backgroundColor}">
                            <div class="pt-1">
                                <div class="v-list-item__title" style="color:rgba(0, 0, 0, 0.87)" :style="{'color': theme.footerIconColor}">{{app_team_name}}</div>
                                <div style="padding-top: 0.5em;"><v-icon style="margin-top: -7px;" medium :color="theme.footerIconColor">mdi-star-circle</v-icon><span style="font-size:1.3em;font-weight: 400;" class="grey--text text--darken-2 pl-1" :style="{'color':theme.footerIconColor + '!important'}">{{app_user_statistic.punkte_gesamt}}</span></div>
                            </div>
                        </v-card-text>
                    </v-card>
                </span>
            </v-menu>
        </v-col>
    </v-row>
</template>

<script>
    import {eventMixin} from '@/utils/event-mixin'
    import EspAvatar from '@/components/ui/EspAvatar.vue'
    import {layoutMixin} from '@/utils/layout-mixin'
    export default {
        components:{
            EspAvatar
        },
        mixins: [eventMixin,layoutMixin],
        props:{
            isMobile:{
                type:Boolean,
                default:false
            },
            isPad:{
                type:Boolean,
                default:false
            },
        },
        watch:{
            selectedEventId: {
                handler(val) {
                    if(val){
                        this.getPlayerinfo();
                    }
                },
                immediate: true
            }
        },
        computed: {
            rowStyle(){
                let width=this.settingsUseMasterSlave?150:250;
                width=(this.isMobile)?70:width;
                return {
                    'max-width':`${width}px`
                }
            }
        },
        data() {
            return {
                initialTimestamp:new Date().getTime()
            }
        },
        methods: {
            onListItemClick(){
                
            }
        },
    }
</script>

<style lang="scss" scoped>
.menuShadow{
  -webkit-box-shadow:0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), -1px 1px 3px 0px rgb(0 0 0 / 0%) !important;
  -moz-box-shadow:0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), -1px 1px 3px 0px rgb(0 0 0 / 0%) !important;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), -1px 1px 3px 0px rgb(0 0 0 / 0%) !important;
}
</style>